
import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message?: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ open, onConfirm, onCancel, message }) => {
  const { t } = useTranslation('manageUsers');
  const [localOpen, setLocalOpen] = useState(false);
  useEffect(() => {
    setLocalOpen(open);
  }, [open]);

  const handleCancel = () => {
    onCancel();
    setLocalOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setLocalOpen(false);
  };

  return (
    <Dialog
      onClose={handleCancel}
      aria-labelledby="customized-dialog-title"
      open={localOpen}
      maxWidth="xs"
      fullWidth
      sx={{ p: 0 }}
    >
      <DialogTitle sx={{ m: 4, p: 4 }}>
        {t('confirmChanges', 'Confirm changes')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleCancel}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.custom.gray[200],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers
        sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="textMD"
          sx={{ my: 4, mx: 6 }}>
          {message || t('confirmSaveMessage', 'Are you sure you want to save these changes?')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 4, mb: 4, mr: 4 }}>
        <Button variant='bad'
          size="lg"
          onClick={handleCancel}>
          {t('cancel', 'Cancel')}
        </Button>
        <Button variant='primary'
          size="lg"
          onClick={handleConfirm}>
          {t('confirm', 'Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
